import { z } from 'zod';
import { messages } from '@/config/messages';
import { validateEmail } from './common-rules';

// Non-mechanical edit: the template's own schema set no messages, so an empty password read zod's
// raw "String must contain at least 1 character(s)" while every other form here says "Password is
// required". Now the same shared rules and wording as the template's other validators.
export const loginSchema = z.object({
  email: validateEmail,
  password: z.string().min(1, { message: messages.passwordRequired }),
  rememberMe: z.boolean().optional(),
});

// generate form types from zod validation schema
export type LoginSchema = z.infer<typeof loginSchema>;
